import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendarClock = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "calendar-clock" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M8.25,17.25h-6a1.5,1.5,0,0,1-1.5-1.5v-12a1.5,1.5,0,0,1,1.5-1.5h13.5a1.5,1.5,0,0,1,1.5,1.5v4.5"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: .75,
			y1: 6.75,
			x2: 17.25,
			y2: 6.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 5.25,
			y1: 3.75,
			x2: 5.25,
			y2: .75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 12.75,
			y1: 3.75,
			x2: 12.75,
			y2: .75
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 17.25,
			cy: 17.25,
			r: 6
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "a",
			points: "19.902 17.25 17.25 17.25 17.25 14.599"
		})
	]
});
export default SvgCalendarClock;
